import React from 'react'
import Header from './Layouts/Header'
import Sidebar from './Layouts/Sidebar'

function Wallet() {
  return (
    <div>
      <>
      <Header/>
      <Sidebar/>    
  <div className="page-wrapper bg-wrapper">
    <div className="content">
      <div className="row">
        <div className="col-sm-12">
          <div className="wallet-header">
            <div className="row">
              <div className="col-xl-6 col-lg-5 col-md-5 d-flex align-items-center">
                <div className="wel-come-name">
                  <h4>My Wallet</h4>
                </div>
              </div>
              <div className="col-xl-6 col-lg-7 col-md-7">
                <div className="welcome-wallet">
                  <div className="bookingrange btn-book ms-2 me-2">
                    <img src="/assets/img/icon/calendar-icon.svg" alt="" />
                    <span>10-26-2022 - 11-1-2022</span>
                  </div>
                  <div className="wallet-list">
                    <a href="javascript:;">
                      <span>
                        <img
                          src="/assets/img/icon/add-wallet.svg"
                          className="me-2"
                          alt=""
                        />
                        Add New Wallet
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="wallet-group">
            <div className="row">
              <div className="col-xl-4 col-md-6 d-flex">
                <div className="card-holder holder-blue">
                  <div className="main-balance-blk">
                    <div className="main-balance">
                      <h4>Main balance</h4>
                      <h3>$4626595</h3>
                    </div>
                    <div className="balance-bit-img">
                      <img src="/assets/img/icon/watch-icon-08.svg" alt="" />
                    </div>
                  </div>
                  <div className="card-valid-blk">
                    <div className="valid-holder me-4">
                      <p>Valid thru</p>
                      <h5>08/21</h5>
                    </div>
                    <div className="valid-holder">
                      <p>Card Holderr</p>
                      <h5>Daniel radcliff</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 d-flex">
                <div className="card-holder holder-light">
                  <div className="main-balance-blk">
                    <div className="main-balance">
                      <h4>Main balance</h4>
                      <h3>$4626595</h3>
                    </div>
                    <div className="balance-bit">
                      <img src="/assets/img/card-icon.png" alt="" />
                    </div>
                  </div>
                  <div className="card-valid-blk">
                    <div className="valid-holder me-4">
                      <p>Valid thru</p>
                      <h5>08/21</h5>
                    </div>
                    <div className="valid-holder">
                      <p>Card Holderr</p>
                      <h5>Daniel radcliff</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-md-6 d-flex">
                <div className="card wallet-widget">
                  <div className="circle-bar circle-bar2">
                    <div className="circle-graph2" data-percent={66}>
                      <b>66%</b>
                    </div>
                  </div>
                  <div className="main-limit">
                    <p>Main Limits</p>
                    <h4>$10,000</h4>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-md-6 d-flex">
                <div className="card wallet-widget">
                  <div className="circle-bar circle-bar3">
                    <div className="circle-graph3" data-percent={66}>
                      <b>66%</b>
                    </div>
                  </div>
                  <div className="main-limit main-second">
                    <p>Seconds</p>
                    <h4>$500</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="quick-transfer-blk">
            <div className="row">
              <div className="col-xl-8 col-md-6 d-flex">
                <div className="card transfer-blk">
                  <div className="transfer-quick">
                    <div className="quick-cont comman-head">
                      <h3>Quick Transfer</h3>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      </p>
                    </div>
                    <div className="form-group bit-coins mb-0">
                      <img src="/assets/img/icon/watch-icon-08.svg" alt="" />
                      <select className="form-control select">
                        <option selected="">25,466654 BTC</option>
                        <option>15,466654 BTC</option>
                        <option>5,466654 BTC</option>
                        <option>2,466654 BTC</option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="ex-forms mb-5">
                        <div className="row">
                          <div className="col-md-5">
                            <div className="form-group bg-hover exchange-bg mb-0">
                              <select className="form-control select">
                                <option selected="">BTC</option>
                                <option>Ethereum</option>
                                <option>Ripple</option>
                                <option>Bitcoin</option>
                                <option>Cardano</option>
                                <option>Litecoin</option>
                                <option>NEO</option>
                                <option>Stellar</option>
                                <option>EOS</option>
                                <option>NEM</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div className="form-group mb-0 side-input">
                              <input type="text" className="form-control " />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="form-group bg-hover mb-5">
                        <select className="form-control select">
                          <option selected="">Aroon james</option>
                          <option>William Stephin</option>
                          <option>Bernardo James</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-8">
                      <div className="trans-text">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className="transfer-now-btn">
                        <a href="javascript:;" className="btn btn-primary">
                          Transfer Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 d-flex">
                <div className="card account-grp">
                  <div className="security-head">
                    <h3>Account Security</h3>
                  </div>
                  <div className="security-group">
                    <div className="verification-blk lock-clr">
                      <div className="security-box">
                        <img
                          src="/assets/img/icon/security-icon-01.svg"
                          alt=""
                        />
                      </div>
                      <div className="security-name-blk">
                        <h4>2FA Authentication</h4>
                        <span className="secure-disable">Disabled</span>
                      </div>
                      <div className="material-switch security-switch">
                        <input
                          id="staff_module"
                          type="checkbox"
                          defaultChecked=""
                        />
                        <label
                          htmlFor="staff_module"
                          className="badge-active"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="security-group">
                    <div className="verification-blk phone-clr">
                      <div className="security-box">
                        <img
                          src="/assets/img/icon/security-icon-02.svg"
                          alt=""
                        />
                      </div>
                      <div className="security-name-blk">
                        <h4>Phone Verification</h4>
                        <span className="secure-active">Active</span>
                      </div>
                      <div className="material-switch security-switch">
                        <input id="staff_module" type="checkbox" />
                        <label
                          htmlFor="staff_module"
                          className="badge-active"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="security-group">
                    <div className="verification-blk mail-clr">
                      <div className="security-box">
                        <img
                          src="/assets/img/icon/security-icon-03.svg"
                          alt=""
                        />
                      </div>
                      <div className="security-name-blk">
                        <h4>Recovery Email</h4>
                        <span className="secure-complete">Not completed</span>
                      </div>
                      <div className="material-switch security-switch">
                        <input
                          id="staff_module"
                          type="checkbox"
                          defaultChecked=""
                        />
                        <label
                          htmlFor="staff_module"
                          className="badge-active"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="buy-form">
            <div className="border-watch">
              <div className="row">
                <div className="col d-flex align-items-center">
                  <div className="watch-head">
                    <h4>Transactions</h4>
                  </div>
                </div>
                <div className="col-auto d-flex">
                  <div className="trad-book-grp">
                    <div className="bookingrange btn-book me-2">
                      <img src="/assets/img/icon/calendar-icon.svg" alt="" />
                      <span />
                    </div>
                    <div className="down-range">
                      <a href="javascript:;">
                        <img src="/assets/img/icon/down-icon.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="transaction-wallet" />
          </div>
          <div className="recent-buy comman-head">
            <h3>Wallet</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            <div className="row">
              <div className="col-md-12">
                <div className="buy-form-crypto mb-0">
                  <div className="border-watch mb-2">
                    <div className="row">
                      <div className="col-xl-9  d-flex align-items-center">
                        <div className="status-blk">
                          <div className="row">
                            <div className="col-lg-2">
                              <div className="action-head">
                                <h4>Latest actions </h4>
                                <span>(Showing 01 to 06 of 100)</span>
                              </div>
                            </div>
                            <div className="col-lg-3 d-flex align-items-center">
                              <div className="form-group date-border cal-icon">
                                <input
                                  type="text"
                                  className="form-control datetimepicker"
                                  placeholder="DD-MM-YYYY"
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 d-flex align-items-center">
                              <div className="form-group date-border cal-icon">
                                <input
                                  type="text"
                                  className="form-control datetimepicker"
                                  placeholder="DD-MM-YYYY"
                                />
                              </div>
                            </div>
                            <div className="col-lg-2 d-flex align-items-center">
                              <div className="form-group bg-hover date-border">
                                <select className="form-control select">
                                  <option>$ Amount</option>
                                  <option>$ 11,723.40</option>
                                  <option>$ 11,723.40 </option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-2 d-flex align-items-center">
                              <div className="form-group bg-hover date-border">
                                <select className="form-control select">
                                  <option>Status</option>
                                  <option>Pending</option>
                                  <option>Succes</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 d-flex align-items-center">
                        <label className="me-2">SortBy:</label>
                        <div className="form-group date-border sort-by cal-icon me-2">
                          <input
                            type="text"
                            className="form-control datetimepicker"
                            placeholder="DD-MM-YYYY"
                          />
                        </div>
                        <div className="down-range date-border">
                          <a href="javascript:;">
                            <img src="/assets/img/icon/down-icon.svg" alt="" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="datatable table  custom-table">
                      <thead>
                        <tr>
                          <th>ID No</th>
                          <th>Currency type</th>
                          <th style={{ minWidth: 110 }}>Total </th>
                          <th style={{ minWidth: 110 }}>Price</th>
                          <th style={{ minWidth: 110 }}>Total Price</th>
                          <th style={{ minWidth: 110 }}>Transaction</th>
                          <th style={{ minWidth: 90 }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td className="currency-type">
                            <img
                              src="/assets/img/icon/watch-icon-07.svg"
                              alt="Award"
                              className="me-2"
                            />
                            Ethereum
                          </td>
                          <td>0.568</td>
                          <td>$119.21</td>
                          <td>$ 1,50,000</td>
                          <td>
                            <span className="custom-badge status-green">
                              <i
                                className="fas fa-arrow-up"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="wallet.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td className="currency-type">
                            <img
                              src="/assets/img/icon/watch-icon-01.svg"
                              alt="Award"
                              className="me-2"
                            />
                            Ripple{" "}
                          </td>
                          <td>1.568</td>
                          <td>$119.21</td>
                          <td>$ 1,50,000</td>
                          <td>
                            <span className="custom-badge status-green">
                              <i
                                className="fas fa-arrow-up"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="wallet.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td className="currency-type">
                            <img
                              src="/assets/img/icon/watch-icon-02.svg"
                              alt="Award"
                              className="me-2"
                            />
                            Cardeno
                          </td>
                          <td>0.268</td>
                          <td>$119.21</td>
                          <td>$ 1,50,000</td>
                          <td>
                            <span className="custom-badge status-green">
                              <i
                                className="fas fa-arrow-up"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="wallet.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td className="currency-type">
                            <img
                              src="/assets/img/icon/watch-icon-03.svg"
                              alt="Award"
                              className="me-2"
                            />
                            NEO{" "}
                          </td>
                          <td>2.568</td>
                          <td>$119.21</td>
                          <td>$ 1,50,000</td>
                          <td>
                            <span className="custom-badge status-green">
                              <i
                                className="fas fa-arrow-up"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="wallet.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td className="currency-type">
                            <img
                              src="/assets/img/icon/watch-icon-08.svg"
                              alt="Award"
                              className="me-2"
                            />
                            BTC{" "}
                          </td>
                          <td>0.568</td>
                          <td>$119.21</td>
                          <td>$ 1,50,000</td>
                          <td>
                            <span className="custom-badge status-green">
                              <i
                                className="fas fa-arrow-up"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="wallet.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="notification-box">
    <div className="msg-sidebar notifications msg-noti">
      <div className="topnav-dropdown-header">
        <span>Messages</span>
      </div>
      <div className="drop-scroll msg-list-scroll" id="msg_list">
        <ul className="list-box">
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">R</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Richard Miles </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item new-message">
                <div className="list-left">
                  <span className="avatar">J</span>
                </div>
                <div className="list-body">
                  <span className="message-author">John Doe</span>
                  <span className="message-time">1 Aug</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">T</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Tarah Shropshire </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">M</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Mike Litorus</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">C</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Catherine Manseau </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">D</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Domenic Houston </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">B</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Buster Wigton </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">R</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Rolland Webber </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">C</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Claire Mapes </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">M</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Melita Faucher</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">J</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Jeffery Lalor</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">L</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Loren Gatlin</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">T</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Tarah Shropshire</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div className="topnav-dropdown-footer">
        <a href="chat.html">See all messages</a>
      </div>
    </div>
  </div>
</>

    </div>
  )
}

export default Wallet
